module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/cqf_driving_change_in_your_school-ce63a24d8020dcfd42ee9390d9853d73.jpeg";